<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">

        <ion-tab-button tab="tab5" href="/tabs/tab5">
          <ion-icon :icon="people" />
          <ion-label>Mijozlar</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/tabs/tab2">
          <ion-icon :icon="statsChart" />
          <ion-label>Statistika</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab4" href="/tabs/tab4">
          <ion-icon :icon="storefrontOutline" />
          <ion-label>Ombor</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab1" href="/tabs/orders">
          <ion-icon :icon="swapHorizontalOutline" />
          <ion-label>Savdolar</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" href="/tabs/tab1">
          <ion-icon :icon="print" />
          <ion-label>Kassa</ion-label>
        </ion-tab-button>

      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue';
import { people, print, statsChart, swapHorizontalOutline, storefrontOutline, ellipse, square, triangle, phonePortraitOutline, personOutline, alertCircleOutline } from 'ionicons/icons';

export default defineComponent({
  name: 'TabsPage',
  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonPage, IonRouterOutlet },
  setup() {
    return {
      print,
      statsChart,
      ellipse,
      people,
      square,
      triangle,
      phonePortraitOutline,
      personOutline,
      alertCircleOutline,
      storefrontOutline,
      swapHorizontalOutline
    }
  }
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

ion-tab-bar {
  --background: #0f0f14;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 8px 4px 12px;
  height: 70px;
}

ion-tab-button {
  --color: #6b7280;
  --color-selected: #00d4aa;
  --background: transparent;
  --background-focused: transparent;
  --background-focused-opacity: 0;
  font-family: 'Outfit', sans-serif;
  position: relative;
  transition: all 0.3s ease;
}

ion-tab-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #00d4aa, #00b4d8);
  border-radius: 0 0 4px 4px;
  transition: width 0.3s ease;
}

ion-tab-button.tab-selected::before {
  width: 40px;
}

ion-tab-button.tab-selected {
  --color: #00d4aa;
}

ion-tab-button ion-icon {
  font-size: 24px;
  margin-bottom: 4px;
  transition: transform 0.2s ease;
}

ion-tab-button.tab-selected ion-icon {
  transform: scale(1.1);
}

ion-tab-button ion-label {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
  font-family: 'Outfit', sans-serif;
}

/* Hover effect for desktop */
@media (hover: hover) {
  ion-tab-button:hover {
    --color: #9ca3af;
  }

  ion-tab-button:hover ion-icon {
    transform: translateY(-2px);
  }

  ion-tab-button.tab-selected:hover {
    --color: #00d4aa;
  }

  ion-tab-button.tab-selected:hover ion-icon {
    transform: scale(1.1);
  }
}

/* Safe area for iOS */
ion-tab-bar {
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
}
</style>